import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { ChartContainer } from "../../view/ChartContainer";
import { debug } from "../../utils";
import { CustomTooltip } from "../../dashboard/components/CustomTooltip";
import { transformPieChartData } from "../../dashboard/utils/chartDataTransformers";
import { VALIDATION_COLORS } from "../../dashboard/constants/chartColors";
import * as statisticService from "../../dashboard/statisticService";
import { connect } from "react-redux";
import { InteractiveLegend } from "../../dashboard/components/InteractiveLegend";
import DeviceDetailsChartSkeleton from "./DeviceDetailsChartSkeleton";

function MsbViolationsChart({ id }) {

    const [scope, setScope] = useState('Month');
    const [rechartsData, setRechartsData] = useState([]);
    const [hiddenSeries, setHiddenSeries] = useState({});
    const [allLegendItems, setAllLegendItems] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchData = async (deviceId) => {
        setIsLoading(true);
        try {
            const sData = await statisticService.getMsbViolationsById(scope, deviceId);
            if (sData && sData.labels && sData.datasets) {
                // Transform data for Recharts and add colors
                const transformed = transformPieChartData(sData).map(item => ({
                    ...item,
                    color: item.name === "Violation" ? VALIDATION_COLORS.violation :
                           item.name === "Suspicious" ? VALIDATION_COLORS.suspicious :
                           VALIDATION_COLORS.normal
                }));
                setRechartsData(transformed);
                // Store all items for legend
                setAllLegendItems(transformed.map(item => ({
                    value: item.name,
                    color: item.color,
                    dataKey: item.name
                })));
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        id && fetchData(id);
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [scope, id])

    
    // useEffect(() => {
    //     id && statisticService.getMsbViolationsById(scope, id).then(data => setChartData(data));
    // }, [scope, id])

    // Handle legend click to toggle series visibility
    const handleToggleSeries = (dataKey) => {
        setHiddenSeries(prev => ({
            ...prev,
            [dataKey]: !prev[dataKey]
        }));
    };

    const monthButton = { label: 'Month', onClick: () => setScope('Day'), className: "btn oct_btn-form-v2 oct_dashboardrange-btn-v2" }
    const dayButton = { label: 'Day', onClick: () => setScope('Month'), className: "btn oct_btn-form-v2 oct_dashboardrange-btn-v2" }
    const buttonToShow = scope === 'Month' ? monthButton : dayButton;

    if (isLoading) {
        return <DeviceDetailsChartSkeleton title="MSB Violations" buttons={[buttonToShow]} isPieChart={true} />;
    }

    return (
        <ChartContainer title={'MSB Violations'} buttons={[buttonToShow]} className="">
            <div className="oct_interactive-legend-wrapper-v2">
                {allLegendItems.length > 0 && (
                    <InteractiveLegend
                        payload={allLegendItems}
                        hiddenSeries={hiddenSeries}
                        onToggleSeries={handleToggleSeries}
                    />
                )}
            </div>
            {(() => {
                const totalValue = rechartsData.reduce((sum, item) => sum + (Number(item.value) || 0), 0);
                const isEmpty = totalValue === 0;

                return (
                    <div className="oct_recharts-wrapper-v2">
                        <ResponsiveContainer width="100%" height="100%" initialDimension={{ width: 10, height: 10 }}>
                            <PieChart className={isEmpty ? "oct_empty-chart-data" : ""}>
                                <Pie
                                    data={isEmpty ? [{ name: 'No MSB Violations', value: 1, color: '#e2e8f0', isEmptyState: true }] : rechartsData.filter(entry => !hiddenSeries[entry.name])}
                                    cx="50%"
                                    cy="50%"
                                    innerRadius={60}
                                    outerRadius={100}
                                    paddingAngle={isEmpty ? 0 : 2}
                                    dataKey="value"
                                    isAnimationActive={!isEmpty}
                                >
                                    {(isEmpty ? [{ name: 'No MSB Violations', value: 1, color: '#e2e8f0', isEmptyState: true }] : rechartsData.filter(entry => !hiddenSeries[entry.name])).map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={entry.color} />
                                    ))}
                                </Pie>
                                <Tooltip content={<CustomTooltip />} />
                            </PieChart>
                        </ResponsiveContainer>
                    </div>
                );
            })()}
        </ChartContainer>
    )
}

function mapStateToProps(state) {
    debug("MsbViolationsChart mapStateToProps", state);
    const deviceDetailsPage = state.deviceDetailsPage;
    const deviceId = deviceDetailsPage.device ? deviceDetailsPage.device.id : null;
    return {
        id: deviceId
    }
}

export default connect(mapStateToProps)(MsbViolationsChart);
